import { ajaxService } from '../../../../../common/Services';
import { ApiUtils } from '../../../../../common/api';

// With the recent login flow updates this api can be better explain with a little bit of context:
//
// 1. You arrive that the landing page to login
// 2. You add your email ONLY (no longer add password+user email)
// 3. You press continue and we submit the email to the BE
// 4. Your login form can be: Form (you need email+password) , Form with two factor authentication (password + email + code), or redirects via URL
//
// This API verifies your email and tries to attempt to offer you the correct login options so you can proceed (check point 4 above)
function verifyEmail(email) {
  return ajaxService
    .get('/api/prelogin/authtype.json', { email })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch(error => ({ error }));
}

export default {
  verifyEmail,
};
